import { takeLatest, put } from 'redux-saga/effects';
import { createTaskRecord, taskCollection } from 'collections/tasks';
import { addTaskToSpaceTab, updateSpaceTabTaskList } from '..';
import { createTaskFromSpaceTabSagaAction } from '../actions';
function* createTaskFromSpaceTabSaga({ payload }) {
    const { projectId, spaceTabId, task } = payload;
    const { taskId, ...rest } = task;
    const taskData = {
        ...task,
        project: {
            projectId
        }
    };
    taskCollection.push([
        taskData
    ], {
        source: 'mutation'
    });
    if (taskId) {
        yield put(addTaskToSpaceTab({
            spaceTabId,
            taskId
        }));
        const response = yield createTaskRecord(projectId, rest);
        // temp task was pushed optimistically above; drop it (real one is pushed
        // by createTaskRecord) — replaces the old createTaskSuccess slice swap.
        taskCollection.externalDelete(taskId);
        yield put(updateSpaceTabTaskList({
            spaceTabId,
            taskId: response.taskId,
            tempTaskId: taskId
        }));
    }
}
export function* watchCreateTaskFromSpaceTabSaga() {
    yield takeLatest(createTaskFromSpaceTabSagaAction.type, createTaskFromSpaceTabSaga);
}
